// en.js
export default {
    main:{
        // 版本更新
        YouMightNeedToRefreshTheCurrentWebPage: "Please click OK to visit the updated website.",
        IncludingShippingFreight: "Including Shipping Freight:",
        // 通用头部【完成】
        home:"Home",
        productCenter:"Product",
        pleaseEnter: "Please enter",
        login:"Log in",
        register: "Register",
        personCenter:"Member center",
        logout: "Log out",
        nopic: "No picture available",
        confirmOperate :"Are you sure you want to perform this action?",
        tip:"Tip",
        sure: "OK",
        cancel: "Cancel",
        invalidRequest:"Sorry, the page you are looking for cannot be found.",
        goHome:"Back to homepage",
        PleaseEnableBrowserCookies:"Please enable browser cookies.",

        // 右侧悬浮工具【完成】
        onlineService:"Skype",
        shareToEmail:"Share via Email",
        yourEmail: "Your email",
        friedEmail: "Friend’s email",
        comments: "Comments",
        shareContent:"This page may be of interest to you. Hope it helps you.",
        send:"Send",
        operationCompletedSuccessfully:"Operation completed",

        // footer国际化【完成】
        professionalManufacturerOfOpticalComponents: "Professional Manufacturer of Optical Components",
        followUs: "Follow Us",
        companyNews: "News",
        contactUs: "Contact Us",
        serviceHotline:"Service Hotline",
        serviceHotlineTime:"( Monday to Sunday 9:00 AM to 6:00 PM (UTC+08:00)Beijing )",
        serviceHotlineTel:"+86 27 87531505",
        email: "Email",
        emailAddress: "overseasales@u-optic.com",
        emailSubject: "Inquiry - Union Optic",
        fax: "Fax",
        faxNum: "+86 27 87531525",
        companyAddress:"Address：Building 19, Bio Accelerator, No. 388, 2nd Hi-Tech road, East Lake Hi-Tech Zone, Wuhan, China 430075",

        // 首页国际化【完成】
        noData:"No more",
        aboutUs:"About Us",
        aboutUsContent:"Union Optic Inc., founded in 2004, is a high-tech company located in Optics Valley of China, specializing in research and development, production and sales of precision optical components.<br />Union Optic has established a comprehensive quality management system and perfect rules and regulations since its foundation. By using enterprise ERP management system, Union Optic offers full product lifecycle support across a range of process, production, quality control, sales, logistics and finance into informatization management to keep it on a correct and efficient pace.",
        viewMore:"More",

        // 联系我们 国际化【完成】
        telephoneExchange:"Telephone",
        telephoneExchangeTel:"+86 27-87531505/87531507",
        salesHotline: "Sales Hotline",
        salesHotlineTel:"+86 27 87531505",
        businessCooperation:"Business Cooperation",
        companyFax:"Fax",
        businessMail:"Email",
        technicalSupport:"Technical Support",
        technicalSupportTel:"+86 27 87531505",
        gwzc: "岗位职责",
        gwyq: "岗位要求",

        // 网站地图 国际化【完成】
        Sitemap: "Sitemap",

        // 服务条款国际化【完成】
        TermsConditions: "Terms & Conditions",
        PrivacyPolicy: "We use Cookie to improve your browsing experience on our website, and improve the performance of our website.",

        // 产品目录国际化【完成】
        catalogues: "Catalogues",
        updateTime: "Last update",
        EDownload: "Download",
        PaperRequest: "Hard Copy Request",
        FirstName:"First name",
        LastName:"Last Name",
        Country:"Country",
        Company:"Company",
        Address:"Address",
        telephone: "Telephone",
        ZipCode:"Postal code",

        // 新闻列表【完成】

        // 新闻详情【完成】
        nextPage: "Next",
        beforePage: "Previous",

        // 购买流程 列表【完成】
        nextP: "Next",
        beforeP: "Previous",

        // 产品分类封面【完成】

        // 产品更多【完成】
        myOrder: "My order",
        myInquiry: "Inquiry",

        // 产品分类详情页
        productFeatures: "Product Features",
        productDetail: "Details",
        productBuild: "Build Your Own Optics",
        feedback: "Feedback",
        Overview:"Overview",
        Specifications:"Specifications",
        CoatingCurve:"Coating Curve",  //镀膜曲线图
        Drawing:"Drawing",
        Mark: "Marking",
        SelectionGuide:"Selection Guide",
        Illustration:"Illustration",
        RetardationCurve:"Retardation Curve",
        Datasheet:"Datasheet",
        Specification: "Specification",
        FeedbackContent: "Content",
        clear: "Clear",
        search: "Search",
        all: "All",
        standardProductAbbr: "standard",
        standardProduct: "Standard Product",
        frequentlyUsedProductAbbr: "Frequently",
        frequentlyUsedProduct: "Frequently Used Product",
        parameter:"Specs",
        product: "Product",
        partNumber: "Part Number",
        priceForOne:"Unit Price",
        totalPrice:"Total",
        monetaryUnit:"$",
        amountConvert:"$ <span class='color-635796'>{amount}</span>",
        commit: "Submit",
        compare: "Compare",
        shopCar:"Cart",
        addShopCar: "Add to cart",
        addInquiry: "Inquiry",
        productInquiry: "Inquiry",
        download: "Download",
        chooseShopNum: "Product Selected: <span class='color-635796'>{num}</span>",
        OnlyShowItemsInStock:"Only show items in stock",
        remark:"Remark",
        fieldIsRequired: "{field} is required",
        fieldIsError: "{field} is invalid",

        // 购物车国际化
        pleaseSelectProduct:"Please select a product",
        pleaseSelectAddress:"Please select an address",
        pleaseSelectBilling:"Please select an invoice address",
        pleaseSelectBillingType:"Please select an invoice type",

        // 注册页面国际化
        Registration:"Create an account",
        MemberLogin: "Member login",
        passwordFinding: "Reset Your Password",
        thePasswordsDoNotMatch:"Two passwords do not match",
        registrationAgreement:"You must acknowledge you have read and agreed to Union Optic's Terms and Conditions",

        // 登录页国际化
        passwordLogin:"Password Login",
        emailLogin:"Email Login",
        telephoneLogin:"Telephone Login",
        // 密码登录
        account:"Account",
        enterMailPhone: "Enter your email",
        password:"Password",
        pleaseEnterYourPassword: "Enter your password",
        forgetPassword: "Forget password?",
        Captcha:"Code",
        pleaseEnterYourCaptcha: "Enter security code",
        loginCode:"Email Code",
        pleaseEnterYourLoginCode: "Enter verification code",
        sendLoginCode: "Get Code",
        rememberMe: "Remember me",
        noAccount: "No account?",
        // 邮箱登录
        emailAccount:"Email",
        enterMail: "Enter your email",
        // 短信登录
        telephoneAccount: "Telephone",
        enterTelephone: "Enter the telephone number",

        // 找回密码
        retypePassword:"Confirm",
        PleaseConfirmYourPassword: "Confirm your password",
        hasAccount: "Already have an account?",

        // 注册
        readAndAccept:"I have read and accepted ",
        termsConditions:"Terms & Conditions",

        //  用户中心
        userCenterSearchPlaceholder: "Product Category/Part Number/Order Number/..",
        MyAddress: "Shipping Address",
        Invoice:"Billing Address",
        MyProfile:"My Profile",
        ChangePassword:"Password",
        addressList: "Shipping Address List",
        addAddress: "Add",
        Name:"Name",
        defaultAddress: "Default",
        setDefault: "Set as default",
        ConsigneeInformation: "Shipping Address",
        receiver: "Contact name",
        country:"Country",
        city:"City",
        invoiceList: "Billing Address List",
        orderCompany: "Company",
        addressDetail: "Address",
        AddressLine1: "Address Line 1",
        AddressLine2: "Address Line 2",
        AddressLine3: "Address Line 3",
        postalCode:"Postal Code",
        ToBePaid:"To be paid",
        ToBeShipped:"To be shipped",
        ToBeReceived:"To be received",
        Completed:"Completed",
        Cancelled:"Cancelled",
        Deleted:"Recycle bin",
        HasDeleted:"Deleted",
        OrderList:"Order list",
        InquiryList:"Inquiry list",
        consignee: "Consignee",
        amountOfMoney: "Amount",
        Status:"Status",
        Manage:"",
        OrderNumber:"Order Number",
        InquiryNumber:"Inquiry Number",
        OrderDate:"Order Date",
        InquiryDate:"Inquiry Date",
        totalNum:"Total Quantity",
        OldPassword: "Old Password",
        NewPassword: "New Password",
        RetypeNewPassword: "Confirm password",
        edit:"Edit",
        delete: "Delete",
        nickname:"Nickname",
        title: "Title",
        suggestionsDetail: "Content",
        person: "Person",
        addInvoice: "Add",
        TaxpayerIdentificationNumber: "VAT Number",
        CompanyAddress: "Address",
        CompanyPhone: "Phone",
        BankName: "Bank name",
        BankAccount: "Bank account",
        defaultInvoice: "Default",
        receiveEmail: "Email",
        InvoiceInfo:"Invoice Address",
        InvoiceType: "Invoice type",
        OwnerType:"Company",
        PayNow: "Checkout",
        ConfirmReceipt:"Confirm receipt",
        ViewContract:"View Contract",
        ViewQuotation:"View Quotation",
        orderDetail:"View Details",
        Detail:"View Details",
        OrderingInformation:"Ordering Information",
        ProductType:"Product category",
        OnlineProducts:"Online products",
        LogisticsInformation:"Logistics information",
        LogisticsCompany:"Logistics company",
        LogisticsNumber:"Logistics number",
        deliveryTime:"Delivery time",
        invoiced:"invoiced",
        NotInvoiced:"Not invoiced",
        Item: "Item",
        ProductSpecifications:"Product Specifications",
        RepeatOrder:"Repeat Order",

        // 产品比对页面
        DownloadToExcel: "Download Excel",
        pleaseEnterPartNumber: "Enter a Part Number",
        add: "Add",
        showAllSpecifications: "All",
        showSelectedSpecifications: "Selected",
        view:"View",

        //购物车相关
        sendTo: "Address",
        freight: "Freight",
        SelectAnAddress: "Select an address",
        SelectAll: "All",
        subTotal: "Total Price",
        shopCarNum: "Quantity",
        StockNum:"Stock",
        varName_stock:"Stock",
        varName_price:"Price",
        AddAllToInquiry:"Add to Inquiry",
        DeleteSelected: "Delete Selected",
        clearShopCar: "Clear",
        clearInquiryCart: "Clear",
        toSettle: "Place Order",

        // 结算页
        AddressInformation: "Address Information",
        ShippingInformation: "Shipping Method",
        ReviewPayment: "Review & Payment",
        searchAddress: "Search from Address Book",
        searchBilling: "Search from Billing Book",
        PlainInvoice: "Value-added Tax Invoice",
        SpecialInvoice: "Value-added Tax Special Invoice",
        PaperSpecialInvoice: "Paper Value-added Tax Special Invoice",
        SameAsShipping: "Same as shipping",

        settlement:"Settlement",
        MyShopCar: "Cart",
        Payment: "Payment completed",
        NotRequiredInvoice: "Not required",
        ElectronicInvoices: "Electronic invoices",
        Cut:"Folded",
        More:"More",

        // 付款页面
        PaymentPage:"Payment",
        OrderInformationHasBeenEntered:"Your order has been successfully submitted",
        ChoosePaymentMethod: "Choose a payment method",
        PaymentQRcode:"Payment QR code",
        paySucess:"Pay sucess",
        pleaseScan:"Please scan the QR code",
        pleaseSurePayStatus:"Please confirm payment status",
        paypalNote:"Note: Your credit card data will be directly processed online through PayPal system.",
        PurchaseOrderNote:"Please complete your procurement information",
        purchaseOrderNo:"Reference/Purchase Order No",
        ContactPhone:"Contact Phone",
        ContactEmail:"Contact Email",

        //付款结果页面
        PayedToDertail:"Purchase successful, we will process it for you as soon as possible!",
        PayedError:"Very sorry, we have not received any notification of successful payment at the moment. It is likely due to network delay. We suggest that you check the payment status later or contact customer service!",

        // 搜索结果
        SearchResults:"Search Results",
        SearchResultsLang:"This site finds for you {keyword} total of {num} Items",
    }
};
